import React from 'react';
import PropTypes from 'prop-types';
import { FormattedPlural } from 'react-intl';

import { Card, CardHeader } from 'material-ui/Card';
import { List } from 'material-ui/List';

import PersonIcon from 'material-ui/svg-icons/social/person';
import ProfileListItem from '../Profile/ProfileListItem';

const style = {
    list: {
        paddingTop: 0,
        paddingBottom: 0,
    },
};

const TrainerSegment = ({trainers}) => {

    if (!trainers || trainers.length === 0) { return false; }

    const iconProps = {
        color: 'rgba(117, 117, 117 ,0.7)',
    };

    const subtitle = (<span>{trainers.length} <FormattedPlural value={trainers.length} one='trainer' other='trainers'/></span>);

    return (
        <Card className="cent-card ">
            <CardHeader
                title="Trainers"
                subtitle={subtitle}
                avatar={<PersonIcon {...iconProps}/>}
            />
            <List style={style.list}>
                {trainers.map((user) => (<ProfileListItem data={user} key={user.userId} actions={null} />))}
            </List>
        </Card>
    );
};

TrainerSegment.propTypes = {
    trainers: PropTypes.arrayOf(PropTypes.object)
};

export default TrainerSegment;
